import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { useReducer, useRef, useCallback, useEffect } from 'react';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';
import { useWalletConnectorEvent } from '../useWalletConnectorEvent/useWalletConnectorEvent.js';
import '@dynamic-labs/multi-wallet';
import { isWalletConnected } from '../../functions/isWalletConnected/isWalletConnected.js';
import { useEventListener } from '../useEventListener/useEventListener.js';

const connectedWalletStateReducer = (state, connectedWalletsMap) => {
    const isConnectedWalletsMapEmpty = Object.values(connectedWalletsMap).length === 0;
    if (isConnectedWalletsMapEmpty && state.didLoad === false) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { connectedWalletsMap, didLoad: true });
};
const useWalletsConnectionState = (wallets) => {
    const [state, setState] = useReducer(connectedWalletStateReducer, {
        connectedWalletsMap: {},
        didLoad: false,
    });
    const refreshKey = wallets.map(({ id }) => id).join('-');
    const connectors = wallets.map(({ connector }) => connector);
    const lastCallTimestamp = useRef(0);
    const computeConnectedStateForWallets = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const connectedWalletsMap = {};
        yield Promise.all(wallets.map((wallet) => __awaiter(void 0, void 0, void 0, function* () {
            connectedWalletsMap[wallet.id] = yield isWalletConnected(wallet);
        })));
        setState(connectedWalletsMap);
    }), [wallets]);
    const handleOnEventUpdate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!wallets.length)
            return;
        const callTimestamp = new Date().getTime();
        const diffFromLastCall = callTimestamp - lastCallTimestamp.current;
        lastCallTimestamp.current = callTimestamp;
        // getConnectedAccounts trigger accountChanged event for Phantom EVM wallets
        // which causes a loop of calls to this function
        if (diffFromLastCall < 1000) {
            logger.warn('computeConnectedStateForWallets: skipping due too many calls.');
            return;
        }
        computeConnectedStateForWallets();
    }), [computeConnectedStateForWallets, wallets.length]);
    useWalletConnectorEvent(connectors, 'accountChange', handleOnEventUpdate);
    useWalletConnectorEvent(connectors, 'disconnect', handleOnEventUpdate);
    useWalletConnectorEvent(connectors, 'chainChange', handleOnEventUpdate);
    useEffect(() => {
        computeConnectedStateForWallets();
    }, 
    /**
     * This is using a custom key to force the useEffect to run only when a connector is
     * added or removed from the connectors list.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refreshKey]);
    /**
     * This is a workaround to detect when the user switches to another tab/extension
     * and then comes back to the dapp.
     */
    useEventListener('focus', computeConnectedStateForWallets);
    return {
        connectedWalletMap: state.connectedWalletsMap,
        didConnectedStateLoad: state.didLoad,
    };
};

export { useWalletsConnectionState };
